import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/undraw_file_synchronization.svg'
import _imports_1 from '@/assets/undraw_access_denied.svg'


const _withScopeId = n => (_pushScopeId("data-v-d58411ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin-bottom" }, "Import your file", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", {
  class: "image",
  style: {"margin":"2rem auto","width":"14rem"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "You have a import in progress!", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Check if it's ready or browse the app freely.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "TAP TO UPLOAD FILE", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Accepted files: XLSX, XLS, CSV", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"bold","margin":"20px 0"} }, " Select a file or drag and drop here ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "XLSX, XLS or CSV", -1))
const _hoisted_10 = { class: "container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { style: {"margin-bottom":"1rem"} }, [
  /*#__PURE__*/_createElementVNode("b", null, "Steps to import visitors")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://beamian-kb.atlassian.net/servicedesk/customer/portal/9/topic/0bf8bc8c-8e4e-48a0-9cde-1ab3cd7db1cd/article/1344226",
  target: "_blank"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "How to import the guest list file")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Create a "),
  /*#__PURE__*/_createElementVNode("b", null, "spreadsheet"),
  /*#__PURE__*/_createTextVNode(" with the information of the visitors you want to import. Don't write any titles on the first row. Include the answers in the following order: ")
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Email (mandatory)"),
  /*#__PURE__*/_createElementVNode("li", null, "Name (mandatory)"),
  /*#__PURE__*/_createElementVNode("li", null, "Phone number*"),
  /*#__PURE__*/_createElementVNode("li", null, "Country code"),
  /*#__PURE__*/_createElementVNode("li", null, "Birthdate (YYYY-MM-DD)"),
  /*#__PURE__*/_createElementVNode("li", null, "Company"),
  /*#__PURE__*/_createElementVNode("li", null, "Job title")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("sub", null, "* Please enter your phone number prefixed with the country code (e.g. +1 for USA) ")
], -1))
const _hoisted_17 = { class: "container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Send template file to email", -1))
const _hoisted_19 = { class: "container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", { class: "image ion-padding" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "There were some errors in your file", -1))
const _hoisted_22 = { class: "box error_box" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "errors_note" }, [
  /*#__PURE__*/_createTextVNode(" Note that rows containing errors "),
  /*#__PURE__*/_createElementVNode("b", null, "will not be imported"),
  /*#__PURE__*/_createTextVNode(". Please fix these lines and try again. ")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "file_ready" }, "Your file is ready to be imported!", -1))
const _hoisted_26 = { class: "file_ready" }
const _hoisted_27 = {
  key: 2,
  style: {"width":"300px","margin":"0 auto"}
}
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The remaining visitors were imported successfuly.", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "container main_message" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "container main_message" }
const _hoisted_36 = { key: 0 }

import {
  alertCircle,
  mailUnread,
  checkmarkCircleOutline,
  arrowBack,
  cloudUploadOutline,
  checkmarkCircle,
} from "ionicons/icons";
import { importVisitors, sendEmailWithExampleFile } from "@/api/visitors";
import { useToasters } from "@/composition/toasters";
import { useContextStore } from "@/stores/context";
import {
  IonPage,
  IonContent,
  IonLoading,
  useIonRouter,
  IonItem,
  IonModal,
  IonIcon,
  IonButton,
  IonFooter,
  IonLabel,
  IonNote,
  onIonViewWillEnter,
  IonText,
  IonFabButton,
  IonProgressBar,
} from "@ionic/vue";
import { reactive, ref } from "vue";
import { IVisitorImportParams } from "@/models/visitor";
import isDate from "@/utils/isDate";
import isEmail from "@/utils/isEmail";
import isString from "@/utils/isString";
import isPhoneNumber from "@/utils/isPhoneNumber";
import Excel from "exceljs";
import { useUserStore } from "@/stores/user";
import { useWindowWidth } from "@/composition/window";
import { event as gtag_event } from "vue-gtag";
import { Storage } from "@ionic/storage";


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportVisitors',
  async setup(__props) {

let __temp: any, __restore: any

const storage = new Storage();
;(
  ([__temp,__restore] = _withAsyncContext(() => storage.create())),
  await __temp,
  __restore()
);

const modal = ref(null as any);
const contextStore = useContextStore();
const userStore = useUserStore();
const router = useIonRouter();
const toasters = useToasters();
const { isMobile } = useWindowWidth();

const isDragging = ref(false);
const file = ref(null);

const state = reactive({
  loading: false,
  error_lines: [] as object[],
  warning_lines: [] as object[],
  modalPreview: false,
  confirmOpen: false,
  total_visitors_imported: 0,
  error_message: {
    row_number: "",
    email: "",
    name: "",
    phone_number: "",
    country_code: "",
    birthdate: "",
    company: "",
    job_title: "",
  } as IVisitorImportParams,
  preview_import: true,
  file_is_valid: false,
  visitors_to_upload: [] as IVisitorImportParams[],
  count_new_visitors: 0,
  import_in_progress: false,
  count_preview_retries: 0,
  count_import_retries: 0,
});

onIonViewWillEnter(async () => {
  await getImportInProgress();
});

const checkImportProgress = async () => {
  state.loading = true;
  await getImportInProgress().then(() => {
    importNewVisitors(false);
  });
  state.loading = false;
};

const readFile = async ($event: Event) => {
  state.visitors_to_upload = [];
  const form = new FormData();
  state.error_lines = [];

  gtag_event("import_file_selected", {
    category: "check-in app",
    method: "Mobile App",
    label: "Import file selected",
  });

  const files =
    $event.type === "drop"
      ? (($event as DragEvent).dataTransfer as DataTransfer).files
      : ($event.target as HTMLInputElement).files;

  if (files && files.length) {
    state.loading = true;

    const file = files[0];
    form.append("file", file);

    const workbook = new Excel.Workbook();
    const reader = new FileReader();

    reader.readAsArrayBuffer(file);
    reader.onload = () => {
      const buffer = reader.result;
      workbook.xlsx
        .load(buffer)
        .then((workbook) => {
          workbook.eachSheet((sheet) => {
            sheet.eachRow((row, index: number) => {
              let new_visitor = {
                email: row.getCell(1).text,
                name: row.getCell(2).text,
                phone_number: row.getCell(3).text,
                country_code: row.getCell(4).text,
                birthdate: row.getCell(5).text,
                company: row.getCell(6).text,
                job_title: row.getCell(7).text,
              };
              state.visitors_to_upload.push(new_visitor);

              // if (!validateVisitor(new_visitor, index)) {
              //   Object.keys(state.error_message).forEach((key) => {
              //     if (state.error_message[key] && key !== "row_number") {
              //       state.error_lines.push({
              //         line: state.error_message.row_number,
              //         error: state.error_message[key],
              //       });
              //     }
              //   });
              // } else {
              //   state.visitors_to_upload.push(new_visitor);
              // }
            });
          });
        })
        .then(() => {
          state.loading = false;

          if (state.error_lines.length > 0) {
            state.modalPreview = true;
          }

          if (
            state.error_lines.length === 0 &&
            state.warning_lines.length === 0 &&
            state.visitors_to_upload
          ) {
            importNewVisitors(state.preview_import);
          }
        });
    };
  }
};

const getImportInProgress = async () => {
  const import_in_progress = await storage.get("import_in_progress");

  if (import_in_progress !== null) {
    state.count_import_retries = 1;
    state.import_in_progress = true;
    state.visitors_to_upload = JSON.parse(import_in_progress);
  } else {
    state.preview_import = true;
    state.visitors_to_upload = [];
  }
};

const importNewVisitors = async (preview: boolean) => {
  state.modalPreview = false;
  state.preview_import = preview;
  state.loading = state.preview_import;

  if (!preview) {
    state.import_in_progress = true;
    if (state.count_import_retries < 1) {
      await storage.set(
        "import_in_progress",
        JSON.stringify(state.visitors_to_upload)
      );
      toasters.addSuccess(
        "Your import has started. We will send you a email confirmation as soon the import is complete."
      );
      state.count_import_retries += 1;
    }
  } else {
    state.loading = true;
  }

  if (!state.preview_import) {
    gtag_event("import_file_started", {
      category: "check-in app",
      label: "Import file started",
    });
  }

  importVisitors(
    state.visitors_to_upload,
    contextStore.event.id,
    state.preview_import
  )
    .then(async (response) => {
      if (response.status === 204) {
        state.modalPreview = false;

        if (!preview) {
          state.loading = false;
          toasters.addWarning(
            "Your import is in progress, please check again in a few minutes."
          );
        } else {
          importNewVisitors(preview);
        }
      }
      if (response.status === 201) {
        state.modalPreview = false;

        if (state.count_preview_retries < 1) {
          setTimeout(function () {
            importNewVisitors(preview);
            state.count_preview_retries += 1;
          }, 3 * 1000);
        }
      }
      if (response.status === 200) {
        if (state.preview_import) {
          if (response.data.error) {
            state.error_lines = response.data.error_lines;
            state.loading = false;
            state.modalPreview = true;
          }
          if (
            response.data.error === 0 &&
            response.data.error_lines.length === 0
          ) {
            state.loading = false;
            state.modalPreview = true;
            state.file_is_valid = true;
          }
          state.count_new_visitors =
            state.visitors_to_upload.length - state.error_lines.length;
        } else {
          state.modalPreview = false;
          state.loading = false;
          state.import_in_progress = false;
          storage.remove("import_in_progress");
          router.push(`/event/${contextStore.event.id}/visitors`);
          state.count_new_visitors = response.data.new;

          if (state.count_new_visitors > 0) {
            toasters.addSuccess(
              `${state.count_new_visitors} visitors imported successfully and the QR Code were sent."`
            );
            await storage.remove("import_in_progress");
          } else {
            toasters.addError(
              "No visitors were imported. Please review your file and try again."
            );
          }
        }
      }
    })
    .catch((error) => {
      state.modalPreview = false;
      state.loading = false;
      // Check the case for a beamian domain error
      if (error.data._errors) {
        let errorMessage = "";
        for (let err of error.data._errors) {
          errorMessage += err.message;
        }
        toasters.addError(errorMessage);
      } else {
        toasters.addError("An error has occured. Please try again later.");
      }
    });
};

const validateVisitor = (
  visitor: IVisitorImportParams,
  index: number | string
) => {
  const invalid_string_message = " is an invalid string";
  const invalid_email_message = " is an invalid email";
  const invalid_phone_number = " is an invalid phone number";
  const invalid_date = " is an invalid date";
  const cannot_be_blank = " can not be blank";
  let visitorIsValid = true;

  resetErrorData();

  state.error_message.row_number = index;

  // Required fields - email and name
  if (visitor.email === undefined || visitor.email === "") {
    state.error_message.email = "Field 'Email' " + cannot_be_blank;
    visitorIsValid = false;
  } else if (!isEmail(visitor.email)) {
    // Check if is a valid email
    state.error_message.email = visitor.email + invalid_email_message;
    visitorIsValid = false;
  }

  if (visitor.name === undefined || visitor.name === "") {
    state.error_message.name = "Field 'Name' " + cannot_be_blank;
    visitorIsValid = false;
  } else if (!isString(visitor.name)) {
    // Check if is a valid string
    state.error_message.name = visitor.name + invalid_string_message;
    visitorIsValid = false;
  }
  if (visitor.country_code != "" && !isString(visitor.country_code)) {
    state.error_message.country_code =
      visitor.country_code + invalid_string_message;
    visitorIsValid = false;
  }
  if (
    visitor.phone_number != "" &&
    !isPhoneNumber(visitor.phone_number as string)
  ) {
    state.error_message.phone_number =
      visitor.phone_number + invalid_phone_number;
    visitorIsValid = false;
  }
  if (visitor.birthdate != "" && !isDate(visitor.birthdate as string)) {
    state.error_message.birthdate = visitor.birthdate + invalid_date;
    visitorIsValid = false;
  }

  return visitorIsValid;
};

const resetErrorData = () => {
  state.error_message = {
    row_number: "",
    email: "",
    name: "",
    phone_number: "",
    country_code: "",
    birthdate: "",
    company: "",
    job_title: "",
  };
};

const openFileDialog = () => {
  document.getElementById("file-upload")?.click();
};

const confirmSendEmail = (value: boolean) => {
  state.confirmOpen = value;
};

const sendEmailExampleFile = () => {
  const event_id = contextStore.event.id;

  state.loading = true;
  sendEmailWithExampleFile(event_id as number)
    .then((response) => {
      state.confirmOpen = false;
      state.loading = false;

      if (response.status === 200) {
        toasters.addSuccess("An email with the example file was sent to you");
      } else {
        toasters.addWarning("Could not get the example file");
      }
    })
    .catch(() => {
      state.confirmOpen = false;
      state.loading = false;
      toasters.addWarning("Could not get the example file");
    });
};

const dragover = (e: Event) => {
  e.preventDefault();
  isDragging.value = true;
};

const dragleave = (e: Event) => {
  isDragging.value = false;
};

const drop = (e: DragEvent) => {
  e.preventDefault();
  if (file.value && e.dataTransfer) {
    (file.value as HTMLInputElement).files = e.dataTransfer.files;
    readFile(e);
  }

  isDragging.value = false;
};

const tryImportFileAgain = () => {
  state.modalPreview = false;
  location.reload();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "flex-desktop",
              style: _normalizeStyle([{"align-items":"center"}, _unref(isMobile) ? '' : 'position: relative; left: -75px;'])
            }, [
              (!_unref(isMobile))
                ? (_openBlock(), _createBlock(_unref(IonFabButton), {
                    key: 0,
                    color: "primary",
                    style: {"margin-right":"20px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), { icon: _unref(arrowBack) }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _hoisted_2
            ], 4),
            _hoisted_3,
            (state.import_in_progress)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "box box_loading",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (checkImportProgress())),
                  style: {"margin":"0 0","cursor":"pointer"}
                }, [
                  _hoisted_4,
                  _hoisted_5,
                  _createVNode(_unref(IonProgressBar), {
                    type: "indeterminate",
                    color: "primary"
                  })
                ]))
              : _createCommentVNode("", true),
            (_unref(isMobile) && !state.import_in_progress)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "box",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (openFileDialog())),
                  style: {"margin":"0 0","cursor":"pointer"}
                }, [
                  _hoisted_6,
                  _hoisted_7,
                  _createElementVNode("input", {
                    id: "file-upload",
                    type: "file",
                    onChange: readFile,
                    style: {"display":"none"}
                  }, null, 32)
                ]))
              : _createCommentVNode("", true),
            (!_unref(isMobile) && !state.import_in_progress)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["dragndrop", { dragging: isDragging.value }]),
                  onDragover: dragover,
                  onDragleave: dragleave,
                  onDrop: drop
                }, [
                  _createVNode(_unref(IonIcon), { icon: _unref(cloudUploadOutline) }, null, 8, ["icon"]),
                  _hoisted_8,
                  _hoisted_9,
                  _createVNode(_unref(IonButton), {
                    style: {"width":"150px","margin":"25px auto"},
                    color: "primary",
                    fill: "solid",
                    expand: "block",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (openFileDialog()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" SELECT FILE ")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("input", {
                    id: "file-upload",
                    ref_key: "file",
                    ref: file,
                    type: "file",
                    onChange: readFile,
                    style: {"display":"none"}
                  }, null, 544)
                ], 34))
              : _createCommentVNode("", true),
            (state.import_in_progress)
              ? (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 3,
                  color: "primary",
                  fill: "clear",
                  expand: "block",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (checkImportProgress())),
                  style: {"margin-bottom":"2rem"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" CLICK HERE TO CHECK YOUR IMPORT ")
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_unref(IonButton), {
                  key: 4,
                  color: "primary",
                  fill: "clear",
                  expand: "block",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (confirmSendEmail(true))),
                  style: {"margin-bottom":"2rem"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonIcon), {
                      slot: "start",
                      icon: _unref(mailUnread)
                    }, null, 8, ["icon"]),
                    _createTextVNode(" Send template file to my email ")
                  ]),
                  _: 1
                }))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("p", null, [
              _createTextVNode(" Read our article "),
              _createVNode(_unref(IonText), { color: "primary" }, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createTextVNode(". ")
                ]),
                _: 1
              })
            ]),
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(IonModal), {
        ref: "confirm",
        "keep-contents-mounted": true,
        "is-open": state.confirmOpen
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonPage), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonContent), null, {
                default: _withCtx(() => [
                  _createElementVNode("section", null, [
                    _createElementVNode("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("p", null, [
                        _createTextVNode(" An email with the template file will be sent to "),
                        _createElementVNode("b", null, _toDisplayString(_unref(userStore).me.email), 1),
                        _createTextVNode(". ")
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonFooter), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("section", null, [
                      _createVNode(_unref(IonButton), {
                        expand: "full",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (sendEmailExampleFile()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Send ")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(IonButton), {
                        expand: "full",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (confirmSendEmail(false)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Cancel ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_unref(IonModal), {
        ref_key: "modal",
        ref: modal,
        "keep-contents-mounted": true,
        "is-open": state.modalPreview
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonPage), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonContent), null, {
                default: _withCtx(() => [
                  _createElementVNode("section", null, [
                    (!state.file_is_valid)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(_unref(isMobile) ? 'container' : '')
                        }, [
                          _hoisted_20,
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            (state.count_new_visitors)
                              ? (_openBlock(), _createBlock(_unref(IonLabel), { key: 0 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), {
                                      icon: _unref(checkmarkCircle),
                                      color: "success",
                                      size: "small",
                                      style: {"margin-block":"-3px"}
                                    }, null, 8, ["icon"]),
                                    _createElementVNode("span", null, " " + _toDisplayString(state.count_new_visitors) + " visitors ready to be imported ", 1),
                                    _hoisted_23
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(IonLabel), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  icon: _unref(alertCircle),
                                  color: "danger",
                                  size: "small",
                                  style: {"margin-block":"-3px"}
                                }, null, 8, ["icon"]),
                                _createElementVNode("span", null, " " + _toDisplayString(state.error_lines.length) + " lines with error ", 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_24
                        ], 2))
                      : _createCommentVNode("", true),
                    (state.file_is_valid)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(_unref(isMobile) ? 'container main_message' : 'text-center')
                        }, [
                          _createVNode(_unref(IonIcon), {
                            class: "verified_file",
                            icon: _unref(checkmarkCircleOutline),
                            color: "primary"
                          }, null, 8, ["icon"]),
                          _hoisted_25,
                          _createElementVNode("p", _hoisted_26, _toDisplayString(state.count_new_visitors) + " visitors ready to be imported ", 1)
                        ], 2))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.warning_lines, (warning_line, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, {
                        key: `import-warning-${index}`
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(warning_line), (warning) => {
                          return (_openBlock(), _createBlock(_unref(IonItem), {
                            class: "ion-invalid",
                            key: `import-warning-line-${warning}`
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonLabel), { color: "warning" }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonIcon), { icon: warning }, null, 8, ["icon"]),
                                  _createTextVNode(" Line " + _toDisplayString(warning), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_unref(IonNote), { slot: "end" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(warning_line[warning]), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], 64))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.error_lines, (error_line, index) => {
                      return (_openBlock(), _createBlock(_unref(IonItem), {
                        key: `import-error-${index}`,
                        class: "ion-invalid"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonLabel), { color: "danger" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(IonIcon), { icon: _unref(alertCircle) }, null, 8, ["icon"]),
                              _createTextVNode(" Line " + _toDisplayString(error_line.line), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_unref(IonNote), { slot: "end" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(error_line.error), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    (!_unref(isMobile))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createElementVNode("div", null, [
                            (state.file_is_valid)
                              ? (_openBlock(), _createElementBlock("section", _hoisted_28, [
                                  _createVNode(_unref(IonButton), {
                                    expand: "block",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (importNewVisitors(false)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Import File ")
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            (!state.file_is_valid)
                              ? (_openBlock(), _createElementBlock("section", _hoisted_29, [
                                  _createVNode(_unref(IonButton), {
                                    color: "warning",
                                    expand: "block",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (importNewVisitors(false)))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" IMPORT FILE ANYWAY ")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_unref(IonButton), {
                                    fill: "clear",
                                    expand: "block",
                                    onClick: tryImportFileAgain
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" TRY AGAIN ")
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (state.total_visitors_imported > state.error_lines.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 3,
                          class: _normalizeClass(_unref(isMobile) ? 'container' : ''),
                          style: {"margin-top":"10px"}
                        }, _hoisted_31, 2))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }),
              (_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      (state.file_is_valid)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
                            _createVNode(_unref(IonButton), {
                              expand: "block",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (importNewVisitors(false)))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Import File ")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      (!state.file_is_valid)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_36, [
                            (state.count_new_visitors)
                              ? (_openBlock(), _createBlock(_unref(IonButton), {
                                  key: 0,
                                  color: "warning",
                                  expand: "block",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (importNewVisitors(false)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" IMPORT FILE ANYWAY ")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createVNode(_unref(IonButton), {
                              fill: "clear",
                              expand: "block",
                              onClick: tryImportFileAgain
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" TRY AGAIN ")
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_unref(IonLoading), {
        "is-open": state.loading,
        message: "Please wait..."
      }, null, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})